/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'

type Props = {
  data?: any
  className: string
  label?: string
}
const TablesWidget11: React.FC<Props> = ({ data = [], className, label = 'Collection Point Activity' }) => {
  const header = [
    { label: 'Facility Name', value: 'name' },
    { label: 'First Collection', value: 'collected' },
    { label: 'From Facility', value: 'received' },
    { label: 'Processed', value: 'processed' },
    { label: 'Recycled', value: 'productionDiversionQuantity' },
    { label: 'Process loss', value: 'wastage' },
    { label: 'To Facility', value: 'supplied' },
    { label: 'Sold', value: 'convertQuanitty' },
  ]
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{label}</span>
          <span className='text-dark mt-1 fw-semibold fs-7'>All values in kgs</span>
        </h3>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-dark bg-light'>
                {header.map((eachHeader, eachInd) => (
                  <th
                    key={eachInd + 1 + ''}
                    className={`${eachInd === 0 ? 'ps-4 min-w-35px rounded-start' : 'min-w-125px'}`}
                  >
                    {eachHeader.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.map((eachData, ind) => (
                <tr key={ind}>
                  {header.map(({ value }, index) => (
                    <td key={index}>
                      <a
                        href='#'
                        className={`${index === 0 ? 'ps-4 min-w-35px' : ''
                          } text-dark text-hover-primary d-block mb-1 fs-6`}
                      >
                        {typeof eachData?.[value] === 'number'
                          ? eachData?.[value]?.toFixed()
                          : eachData?.[value]}
                      </a>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export { TablesWidget11 }
